import { BoxSx, Icon, Target } from "@modernatx-internal/ui-kit-react";
import React from "react";

interface NavLinkProps {
  active?: boolean;
  children: React.ReactNode;
  href?: string;
  index: number;
  icon?: React.ComponentProps<typeof Icon>["icon"];
  fontWeight?: BoxSx["fontWeight"];
  onClick?: React.MouseEventHandler;
}

export const NavLink: React.FC<NavLinkProps> = ({
  active,
  children,
  href,
  icon,
  index,
  onClick,
  fontWeight = "medium",
  ...other
}) => {
  return (
    <Target
      {...other}
      sx={{
        color: active ? "accent01" : "inherit",
        display: "flex",
        fontSize: 2,
        fontWeight: fontWeight,
        gap: 2,
        lineHeight: 2,
        py: 6,
        backgroundImage: active
          ? (theme) => `linear-gradient(to bottom, ${theme.colors?.accent01} 75%, transparent 75%)`
          : "transparent",
        backgroundPosition: "0 3.25em",
        backgroundRepeat: "repeat-x",
        backgroundSize: "1px 4px",
        whiteSpace: "nowrap",
        ":hover": {
          backgroundImage: (theme) =>
            `linear-gradient(to bottom, ${theme.colors?.accent01} 75%, transparent 75%)`
        }
      }}
      data-nav-link={index}
      href={href}
      onClick={onClick}
    >
      {children}
      {!!icon && <Icon color="inherit" icon={icon} />}
    </Target>
  );
};
